/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(document).ready(function () {
//     if (location.pathname.includes("/en")) {
//         window.location.replace("/");
//     }

//     $("body").on("click", '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
//         if ($("#terms").is(":checked")) {
//             $(this).submit();
//         } else {
//             alert("Du skal acceptere vilkår og betingelser.");
//             return false;
//         }
//     });

//     $(".Product__SlideshowNavScroller").flickity({
//         asNavFor: ".Product__Slideshow",
//         contain: true,
//         pageDots: false,
//         prevNextButtons: false
//     });

//     setTimeout(() => {
//         $("#currency-selector").append($("#currencies"));
//     }, 1000);

//     // viabill
//     (function () {
//         var o = document.createElement("script");
//         o.type = "text/javascript";
//         o.async = true;
//         o.src = "https://pricetag.viabill.com/script/CZwMAcCfb8w%3D";
//         var s = document.getElementsByTagName("script")[0];
//         s.parentNode.insertBefore(o, s);
//     })();
// });

document.addEventListener("DOMContentLoaded", function () {
  if (location.pathname.includes("/en")) {
    window.location.replace("/");
  }

  const cartDrawer = document.querySelector(".cart-drawer__footer");
  if (cartDrawer) {
    cartDrawer.addEventListener("submit", function (event) {
      if (document.querySelector("#terms").checked) {
        document.querySelector("#cartform").submit();
      } else {
        event.preventDefault();
        alert("Du skal acceptere vilkår og betingelser.");
        return false;
      }
    });
  }

  const currencySelector = document.querySelector(".scm-popup-container");
  console.log(currencySelector);

  const langCurrencyContainer = document.querySelector(
    "#lang-currency-container"
  );

  setTimeout(() => {
    const langSelector = document.querySelector(".weglot-container");

    langCurrencyContainer.appendChild(currencySelector);
    langCurrencyContainer.appendChild(langSelector);
    console.log(langSelector);
  }, 1000);

  viabill(function () {
    const viaBillScript = document.createElement("script");
    viaBillScript.type = "text/javascript";
    viaBillScript.async = true;
    viaBillScript.src = "https://pricetag.viabill.com/script/CZwMAcCfb8w%3D";
    const tag = document.getElementsByTagName("script")[0];
    tag.parentNode.insertBefore(viaBillScript, tag);
  })();
});
